import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { saveAs } from 'file-saver';

import fetchAuditTrailExport from '@data/auditTrail/fetchAuditTrailExport';
import { useSnackbarNotification } from '@store/snackbarNotification';

const getAuditTrailExport = ({ queries }) => {
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    return useMutation({
        mutationFn: async () => {
            onChangeSnackbarNotification({
                status: 'info',
                title: 'Proses Download Data',
                description: (
                    <>
                        Silahkan menunggu, sedang mengunduh <b>Audit-Trail-Summary.xlsx</b>
                    </>
                ),
                duration: 5,
            });

            const data = await fetchAuditTrailExport({ queries });

            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            saveAs(blob, `Audit Trail Export.xlsx`);
        },
        onSuccess: async () => {
            onChangeSnackbarNotification({
                status: 'success',
                title: 'Sukses Download Data',
                description: (
                    <>
                        <b>Audit Trail Export.xlsx</b> berhasil diunduh
                    </>
                ),
                duration: 5,
            });
        },
        onError: async (error) => {
            let errorMessage = error.message || 'Terdapat kesalahan sistem, Silahkan coba beberapa saat lagi.';
            if (error instanceof AxiosError && error.response?.data instanceof Blob) {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                errorMessage = json?.message ?? errorMessage;
            }

            onChangeSnackbarNotification({
                status: 'error',
                title: 'Export Gagal',
                description: errorMessage,
                duration: 3,
            });
        },
    });
};

export default getAuditTrailExport;
